module.exports = __webpack_public_path__ + "static/007-725b68e7491dd3660d1d437a24c23d23.png";